module.exports = __webpack_public_path__ + "static/media/truckImg1.0149feb7.webp";